const initialState = {
  loading: true,
  lessons: [],
  lessonsByGroup: [],
};

const lessonsReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case "GET_LESSONS_DATA": {
      return {
        ...state,
        loading: actions.loading,
        lessons: actions.data,
      };
    }
    case "UPDATE_LESSON": {
      return { ...state, lessons: actions.data };
    }
    case "GET_LESSONS_BY_GROUP": {
      return { ...state, lessonsByGroup: actions.data };
    }
    case "CLEAR_LESSON": {
      return { ...state, lessonsByGroup: [] };
    }
    default:
      return state;
  }
};
export default lessonsReducer;
